import React, { Component } from 'react'
import { connect } from 'react-redux'

class OverlayComponent extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	render() {
		return (
			<div className={`cams__overlay ${(this.props.overlay.message !== '' ? '' : 'cams__overlay__hidden')}`}>
				<div className="cams__overlay__message">
					{this.props.overlay.message}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		overlay: state.overlay
	}
};

export default connect(mapStateToProps)(OverlayComponent)


// WEBPACK FOOTER //
// ./src/application/templates/overlay.js